export default __webpack_public_path__ + "static/media/icon-trash-blue.9999b7ea.svg";